/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';

import globalStyles from '../../utility/styles';

const styles={
  box: {
    backgroundColor: '#fff',
    borderRadius:'1%',
    overflow:'hidden',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
  },
  status:{
    float:'right',
    padding: '15px',
    fontSize: '18px',
  }
}

const PhotoComponent = ({photoUrl, locked, status, name, showImage})=>{
  return (
      <div style={styles.box}>
        <img width="100%" src={photoUrl} alt="profile"/>
        <div style={globalStyles.header}>
          {name}
        </div>
        {
          locked &&
          <div className="circle" style={styles.status}>
            Locked
          </div>
        }
      </div>
  )
}

export default PhotoComponent;


// WEBPACK FOOTER //
// ./src/screens/profile/photo-component.js